import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/udaipur.jpg";
import Newsletter from "../../shared/Newsletter";

const Udaipur = () => {
  return (
    <>
      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">Udaipur</h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>City Palace</li>
                      <li>The Lake Palace</li>
                      <li>FatehSagar Lake</li>
                      <li>City Palace</li>
                      <li>Sahelion Ki Bari</li>
                      <li>JagdishMandir</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Udaipur
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    Udaipur, the capital of the former princely state of Mewar
                    is a beautiful city in Rajasthan, India. Udaipur City,
                    formally known as the city of lakes. Udaipur is also
                    referred to as the "Venice of the East", the "Most Romantic
                    City of India" and the "Kashmir of Rajasthan". Udaipur the
                    City of Lakes is one among the most romantic and most
                    beautiful cities of India. The city of Dawn, Udaipur is a
                    lovely land around the azure water lakes, hemmed in by the
                    lush hills of the Aravalis. A vision in white drenched in
                    romance and beauty, Udaipur city of Rajasthan state is a
                    fascinating blend of sights, sounds and experiences - an
                    inspiration for the imagination of the poets, painters and
                    writers.
                  </p>
                  <p>
                    Udaipur offers numerous tourist attractions to gratify the
                    thirst of tourists. Places of interest could be different
                    for different persons and keeping this fact in mind, we have
                    tried to provide you information regarding the best tourist
                    attractions of Udaipur. The imperial city of Udaipur boasts
                    of picturesque lakes, massive forts, beautiful palaces, art
                    museums, well-laid gardens, architectural temples, colorful
                    fairs and festivals. Anything from these places could be
                    your place of interest. You will definitely be mesmerized by
                    the scenic beauty of the large lakes that form a
                    picture-perfect background of Udaipur city.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    City Palace
                  </h2>
                  <p>
                    A fusion of Medieval European and Chinese architecture, the
                    City Palace was built by Maharaja Udai Singh. This marble
                    monument is situated on the eastern banks of Lake Pichola. A
                    triple arched gate called Tripolia, built in 1725, provides
                    the entry to the palace. Lake PicholaPichola Lake derives
                    its name from Pichola Village was submerged and MaharanaUdai
                    Singh enlarged the lake after he founded the city. He built
                    a masonry dam known as Badipol and lake is now 4 km long and
                    3 km wide.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    The Lake Palace
                  </h2>
                  <p>
                    The Lake Palace is located on the Jag Niwas Island and
                    covers the whole of 1.5 hectare of the island in the middle
                    of the Pichola Lake. Built by MaharanaJagat Singh in 1743 it
                    was meant as a royal summer palace and now converted in to a
                    five star palace hotel.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    FatehSagar Lake
                  </h2>
                  <p>
                    This delightful lake, bordered by hills and woodland was
                    constructed by Maharana jai Singh to the north of Lake
                    Pichola. It is an artificial lake dug up in 1678,
                    reconstructed by MaharanaFateh Singh A canal links the two,
                    via SwaroopSagar and Rang Sagar Lakes. The beautiful Nehru
                    Island as well as an islet bearing a solar observatory rises
                    from the lake.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Sahelion Ki Bari
                  </h2>
                  <p>
                    Maharana Sangram Singh builds this in the mid 18th century.
                    The 'garden of the maidens' brings to mind the lifestyle of
                    the ladies of the court. The delightful gardens appear
                    discreet and in impeccable taste. There are four pools with
                    dainty kiosks, and all around are flowerbeds, lawns, pools
                    and fountains protected by a series of walls and shady
                    trees.
                  </p>
                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    JagdishMandir
                  </h2>
                  <p>
                    Built by MaharanaJagat Singh I in 1651 the temple enshrines
                    a black stone image of Lard Vishnu. There is a brass image
                    of Garuda the Lord bird carrier. The exterior and the plinth
                    are covered with base relief of alligators; elephants,
                    horsemen and celestial musicians rise in tiers. Chanting,
                    bells and music can be heard throughout the day. It is the
                    largest and most splendid temple of Udaipur.
                  </p>
                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Udaipur;
